import { render, staticRenderFns } from "./QueryAnemonefishI.vue?vue&type=template&id=f31b6032&"
import script from "./QueryAnemonefishI.vue?vue&type=script&lang=js&"
export * from "./QueryAnemonefishI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports